export const preloadImagesAsync = (imageUrls: string[]): Promise<void> => {
  return Promise.all(
    imageUrls.map(
      (src) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve();
          img.onerror = () => resolve();
        })
    )
  ).then(() => {});
};
